// extracted by mini-css-extract-plugin
module.exports = {"root":"CardRail_root___HwO2","scrollContainer":"CardRail_scrollContainer__Yx1_I","goForwardButton":"CardRail_goForwardButton__F1UeM","goBackButton":"CardRail_goBackButton__H4ZWJ"};